var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgBendLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 69,
    viewBox: "0 0 209 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9919 5.68294C11.9919 2.54434 9.44752 0 6.30892 0C3.17032 0 0.625977 2.54434 0.625977 5.68294V43.5692C0.625977 57.1698 11.6514 68.1953 25.252 68.1953C38.8527 68.1953 49.8781 57.1698 49.8781 43.5692C49.8781 29.9686 38.8527 18.9431 25.252 18.9431C22.1134 18.9431 19.5691 21.4875 19.5691 24.6261C19.5691 27.7647 22.1134 30.309 25.252 30.309C32.5754 30.309 38.5122 36.2458 38.5122 43.5692C38.5122 50.8926 32.5755 56.8294 25.252 56.8294C17.9286 56.8294 11.9919 50.8926 11.9919 43.5692V5.68294Z",
    fill: "url(#paint0_linear_534_20067)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M203.317 0C200.179 0 197.635 2.54434 197.635 5.68294V43.5692C197.635 50.8926 191.698 56.8294 184.374 56.8294C177.051 56.8294 171.114 50.8926 171.114 43.5692C171.114 36.2458 177.051 30.309 184.374 30.309C187.513 30.309 190.057 27.7647 190.057 24.6261C190.057 21.4875 187.513 18.9431 184.374 18.9431C170.774 18.9431 159.748 29.9686 159.748 43.5692C159.748 57.1698 170.774 68.1953 184.374 68.1953C197.975 68.1953 209 57.1698 209 43.5692V5.68294C209 2.54434 206.456 0 203.317 0Z",
    fill: "url(#paint1_linear_534_20067)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.439 30.309C125.896 30.309 122.688 31.6911 120.305 33.9567C117.757 36.3795 116.179 39.7853 116.179 43.5692V62.5123C116.179 65.6509 113.635 68.1953 110.496 68.1953C107.358 68.1953 104.813 65.6509 104.813 62.5123V43.5692C104.813 36.544 107.762 30.1984 112.474 25.7191C116.885 21.5254 122.867 18.9431 129.439 18.9431C143.04 18.9431 154.065 29.9686 154.065 43.5692V62.5123C154.065 65.6509 151.521 68.1953 148.382 68.1953C145.244 68.1953 142.699 65.6509 142.699 62.5123V43.5692C142.699 36.2458 136.763 30.309 129.439 30.309Z",
    fill: "url(#paint2_linear_534_20067)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5914 53.8285L88.5963 53.8344C89.5766 53.0307 90.8305 52.5483 92.1971 52.5483C95.3357 52.5483 97.88 55.0927 97.88 58.2313C97.88 60.1266 96.9521 61.8053 95.5258 62.8378C85.8576 70.5537 71.7266 69.9352 62.7739 60.9825C53.1568 51.3654 53.1568 35.773 62.7739 26.1559C72.3328 16.597 87.7942 16.5392 97.4254 25.9827C99.7581 28.2699 99.7739 32.0193 97.4664 34.3268L85.5316 46.2616C83.3123 48.481 79.714 48.481 77.4947 46.2616C75.2754 44.0423 75.2754 40.4441 77.4947 38.2247L84.643 31.0764C79.9695 29.4132 74.5502 30.4534 70.8108 34.1928C65.6323 39.3713 65.6323 47.7671 70.8108 52.9456C75.6763 57.8111 83.3826 58.1056 88.5914 53.8285Z",
    fill: "url(#paint3_linear_534_20067)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_534_20067",
    x1: 0.625978,
    y1: 34.0907,
    x2: 209,
    y2: 34.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_534_20067",
    x1: 0.625978,
    y1: 34.0907,
    x2: 209,
    y2: 34.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_534_20067",
    x1: 0.625978,
    y1: 34.0907,
    x2: 209,
    y2: 34.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC060"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_534_20067",
    x1: 0.625978,
    y1: 34.0907,
    x2: 209,
    y2: 34.0907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02A0A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2EC060"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBendLogo);
export default __webpack_public_path__ + "static/media/bend-logo.6f35bd51254ec03e9dfa871af135bc09.svg";
export { ForwardRef as ReactComponent };